/**
 * Reference Cards — mobile accordion
 *
 * On viewports < 992px, clicking a card toggles .step-active
 * (expands its body). Only one card open at a time.
 */
export function init() {
    const steps = document.querySelectorAll('.reference-cards__step');
    if (!steps.length) return;

    steps.forEach((step) => {
        step.addEventListener('click', () => {
            if (window.innerWidth < 992) {
                if (step.classList.contains('step-active')) {
                    step.classList.remove('step-active');
                } else {
                    steps.forEach((s) => s.classList.remove('step-active'));
                    step.classList.add('step-active');
                }
            }
        });
    });
}
